<template>
  <div :style="homeStyle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    marginTop: {
      type: Number,
      default: 0
    },
    marginBottom: {
      type: Number,
      default: 0
    }
  },
  computed: {
    homeStyle() {
      return { marginTop: `${this.marginTop}px`, marginBottom: `${this.marginBottom}px` };
    }
  }
};
</script>
